import {
    HubConnectionState,
    HubConnectionBuilder,
    LogLevel,
    HubConnection
} from '@microsoft/signalr';
import { LOCAL_USER_DATA } from '../../constants';
import { SessionStorage } from '../AuthContextProvider/session-storage';
export let connection: HubConnection;

type SignalRNegotiateResponse = {
    Url?: string;
    AccessToken?: string;

};

export const signalRRegistration = async () => {

    const userData = JSON.parse(sessionStorage.getItem(LOCAL_USER_DATA) || '{}') as {
        user?: string;
        userId?: string;
        roleTypeId?: number;
    };

    const storedConnectionId = sessionStorage.getItem("signalRConnectionId");

    // Check if the connection already exists and if the stored connectionId matches
    if (connection && connection.state === HubConnectionState.Connected && storedConnectionId) {
        //Reusing existing SignalR connection
        return;
    }
    const subscriptionKey = process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY || '';
    const authToken = SessionStorage.getOktaAuthToken();
    const signalRNegotiateUrl =
        process.env.REACT_APP_SIGNALR_URL ||
        'https://apim-etn-es-el-api-dev-eastus.azure-api.net/signalrconnection/negotiate?negotiateVersion=1';

    const negotiateResponse = await fetch(
        signalRNegotiateUrl,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-ms-signalr-userid': userData?.userId || '',
                ...(subscriptionKey ? { 'Ocp-Apim-Subscription-Key': subscriptionKey } : {}),
                ...(authToken ? { Authorization: authToken } : {}),
            },
        }
    );

    if (!negotiateResponse.ok) {
        sessionStorage.removeItem('signalRConnectionId');
        return;
    }

    const negotiateData = (await negotiateResponse.json()) as SignalRNegotiateResponse;
    const signalRBaseUrl = (process.env.REACT_APP_SIGNALR_BASE_URL || '').replace(/\/+$/, '');
    const signalRChatUrlFromBase = signalRBaseUrl ? `${signalRBaseUrl}/?hub=chat` : '';
    const signalRUrl = signalRChatUrlFromBase || negotiateData.Url || '';
    const signalRAccessToken = negotiateData.AccessToken || '';

    if (!signalRUrl || !signalRAccessToken || !signalRUrl.includes('hub=chat')) {
        sessionStorage.removeItem('signalRConnectionId');
        return;
    }

    // Create a new connection if not already connected
    connection = new HubConnectionBuilder()
        .withUrl(signalRUrl, {
            accessTokenFactory: () => signalRAccessToken,
        })
        .configureLogging(LogLevel.Information)
        .withAutomaticReconnect()
        .build();

    connection.onreconnected((connectionId) => {
        sessionStorage.setItem('signalRConnectionId', connectionId || '');
    });

    connection.onclose(() => {
        sessionStorage.removeItem('signalRConnectionId');
    });

    try {
        await connection.start();
        sessionStorage.setItem('signalRConnectionId', connection.connectionId || '');
    } catch (err) {
        sessionStorage.removeItem('signalRConnectionId');
    }
};
